const { __ } = wp.i18n;
export default [
  {
    value: "no-repeat",
    label: __("No repeat", "uipress-lite"),
  },
  {
    value: "repeat-x",
    label: __("Repeat x", "uipress-lite"),
  },
  {
    value: "repeat-y",
    label: __("Repeat y", "uipress-lite"),
  },
  {
    value: "repeat",
    label: __("Repeat", "uipress-lite"),
  },
];
